module.exports = __webpack_public_path__ + "img/ide-list.8d26d5fa.svg";